const Pagination = ({
                        pages = 5,
                        currentPage = 1,
                        onPageChange = (num) => {}
                    }) => {

    const allPages = Array.from({length: pages}, (x, i) => i);
    return (
        <ul className={'pagination'}>
            {allPages.map((page) =>
                <li key={page} className={`${currentPage === page + 1 ? 'active' : ''}`}
                    onClick={e => onPageChange(page + 1)}>{page + 1}</li>
            )}
        </ul>
    )
}

export default Pagination;
